"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = require("moment");
function calcBuyerAge(birthday) {
    if (birthday === '') {
        return NaN;
    }
    var bd = moment_1.utc(birthday, 'DD.MM.YYYY');
    var cd = moment_1.utc(new Date(), 'DD.MM.YYYY');
    return cd.diff(bd, 'years');
}
exports.calcBuyerAge = calcBuyerAge;
//# sourceMappingURL=calcBuyerAge.js.map